import { useMemo } from "react";

export const useAlignment = (headerAlignment: string, S: { [key: string]: string }) => {
    const alignmentClass = useMemo(() => {
        switch (headerAlignment) {
            case "ALIGNMENT_LEFT":
                return S.alignmentLeft;
        }
    }, [headerAlignment, S]);

    return {
        alignmentClass,
    };
};
